export default __webpack_public_path__ + "static/media/3.afff5d15.webp";